module.exports = __webpack_public_path__ + "static/media/logo-mid.d264d5df.png";